<template>
  <el-skeleton style="opacity: 0.2; margin: 10px" animated>
    <template #template>
      <el-skeleton-item variant="image" style="width: 0px; height: 0px" />
    </template>
  </el-skeleton>
</template>
<script>
export default {};
</script>
